<script setup>
import { ref, watch, Teleport } from "vue";
import { RouterLink, RouterView } from "vue-router";
import { useUserStore } from "./stores/storeUser";

const userStore = useUserStore();
const userData = userStore.data;
const userLoggedIn = ref(false);
const showFeedback = ref(false);

if (userStore.data?.userType !== undefined) {
  userLoggedIn.value = true;
}

watch(
  () => userStore.data,
  (newVal) => {
    if (userStore.data.userType !== undefined) {
      userLoggedIn.value = true;
    } else {
      userLoggedIn.value = false;
    }
  }
);
</script>

<template>
  <div
    class="container d-flex flex-column flex-grow-1 p-0"
    style="max-width: 1320px"
  >
    <div class="flex-grow-1">
      <nav
        v-if="$route.name !== 'print'"
        class="navbar navbar-expand-md bg-body-tertiary bg-gradient"
      >
        <div class="container-fluid">
          <RouterLink
            class="navbar-brand p-0 align-item-center"
            :to="{
              name: 'main',
            }"
          >
            <img
              src="@/assets/valgsmart_60x60.png"
              alt="Logo"
              width="40"
              height="40"
              class="d-inline-block align-text-top me-2"
            />
            <span class="pt-5"
              >ValgSmart<span class="d-none d-md-inline fst-italic">
                - gjør valgene enklere</span
              ></span
            ></RouterLink
          >
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
            v-if="userLoggedIn && userStore.data.firstName !== 'Demo'"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div
            class="collapse navbar-collapse"
            id="navbarNavDropdown"
            v-if="userLoggedIn && userStore.data.firstName !== 'Demo'"
          >
            <ul class="navbar-nav ms-auto d-sm-none d-md-block">
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {{ userStore.data.firstName }} {{ userStore.data.lastName }}
                  <span v-if="userStore.data.gradeGroup"
                    >, {{ userStore.data.gradeGroup }}.klasse</span
                  >
                  <font-awesome-icon
                    :icon="['fal', 'user']"
                    class="text-success me-2 ms-2"
                    size="lg"
                  />
                </a>
                <ul class="dropdown-menu collapse">
                  <li>
                    <span class="dropdown-item">
                      {{ userData.school }}
                    </span>
                  </li>
                  <li><hr /></li>
                  <li>
                    <RouterLink
                      class="dropdown-item"
                      :to="{
                        name: 'main',
                      }"
                      >Gå til velkomstsiden</RouterLink
                    >
                  </li>

                  <li>
                    <RouterLink
                      class="dropdown-item"
                      :to="{
                        name: 'logout',
                      }"
                      >Gå til innlogging</RouterLink
                    >
                  </li>
                </ul>
              </li>
            </ul>
            <div class="d-none d-sm-block d-md-none">
              {{ userStore.data.firstName }} {{ userStore.data.lastName }},
              {{ userStore.data.gradeGroup }}.klasse
              {{ userStore.data.school }}
              <hr />
              <RouterLink
                class="btn btn-primary mt-3"
                to="/logout"
                >Logg ut</RouterLink
              >
            </div>
          </div>
        </div>
      </nav>
      <div class="flex-grow-1 m-3">
        <div class="row">
          <div class="col-md-12">
            <RouterView />
          </div>
        </div>
      </div>
    </div>
  </div>
  <footer
    v-if="$route.name !== 'print'"
    class="bg-dark text-white text-center"
    id="footer"
  >
    <p class="mb-0">
      © 2025 Vestnes kommune.
      <RouterLink
        to="/policy"
        class="text-white text-decoration-underline"
        >Personvern</RouterLink
      >
    </p>
  </footer>
  <Teleport to="body">
    <span class="d-none d-md-inline">
      <div
        class="row feedback-text bg-transparent"
        :class="showFeedback ? 'feedback-text-active' : 'feedback-text'"
      >
        <div
          class="col-md-10 bg-white rounded-3 p-2 border border-2 border-black"
        >
          <p>
            Vi setter stor pris på om du kan gi oss tilbakemelding på ValgSmart
            gjennom en kort Forms, etter at du har prøvd systemet.<br />
            <a
              href="https://forms.office.com/e/fby8axJCmp"
              target="_blank"
              class="text-decoration-none text-white btn btn-success"
              >Gi tilbakemelding her</a
            >
          </p>
        </div>
        <div class="col-md-2 bg-transparent">
          <button
            type="button"
            name=""
            id=""
            class="btn btn-primary vertical-button"
            @click="showFeedback = !showFeedback"
          >
            Feedback
            <font-awesome-icon
              :icon="['fal', 'comment-dots']"
              class="text-white me-2 ms-2"
              style="transform: rotate(-270deg)"
              size="lg"
            />
          </button>
        </div>
      </div>
    </span>
  </Teleport>
</template>

<style scoped>
.headerColor {
  background: #3f51b5;
}

.navbar {
  background: #283593 !important;
  background-image: var(--bs-gradient) !important;
  color: white;
}

.dropdown-menu .dropdown-item {
  color: black;
}
.dropdown-menu .dropdown-item:hover {
  background: #3f51b5 !important;
  color: white !important;
}

.navbar a {
  color: white !important;
}
.navbar a:hover {
  color: gray;
}

.navbar .dropdown-menu {
  background: #283593 !important;
  background-image: var(--bs-gradient) !important;
  color: white;
}

.container {
  background: #fff3e0;
  border-left: #ccc 2px solid;
  border-right: #ccc 2px solid;
}

.vertical-button {
  writing-mode: vertical-lr;
  border: 1px solid #000 !important;
  left: -20px;
  position: relative;
  padding-left: 0% !important;
  padding-right: 0% !important;
  padding-top: 15px !important;
  padding-bottom: 15px !important;
  transform-origin: left center;
  gap: 0.5rem;
  animation: bounce 5s ease-in-out;
}
.feedback-text:hover,
.feedback-text-active {
  opacity: 1 !important;
  animation: slideIn 0.5s ease-out forwards;
}

@keyframes slideIn {
  from {
    left: -230px;
  }
  to {
    left: 0;
  }
}

.feedback-text {
  position: fixed;
  left: -230px;
  bottom: 50px;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 10px;
  width: 300px;
  opacity: 0.4;
  text-align: center;
}

@keyframes bounce {
  0% {
    transform: rotate(0) translateY(10px) translateX(0);
  }
  20% {
    transform: rotate(0) translateY(-10px) translateX(0);
  }
  40% {
    transform: rotate(0) translateY(10px) translateX(0);
  }
  60% {
    transform: rotate(0) translateY(-10px) translateX(0);
  }
  80% {
    transform: rotate(0) translateY(5px) translateX(0);
  }
  100% {
    transform: rotate(0) translateY(0) translateX(0);
  }
}

.hide-text .btn-text {
  opacity: 0;
  width: 0;
  overflow: hidden;
}
</style>
